import { rootReducer } from './rootReducer'

export * from './slices/slices'
export * from './slices/sliceGenerator'

export default rootReducer
